import DeleteIcon from "@material-ui/icons/Delete";
import { get } from "lodash";
import React from "react";
import { Button, DeleteWithConfirmButton } from "react-admin";

const CantDelete = () => (
	<Button label="resources.user-wtrs.actions.cant_delete" disabled>
		<DeleteIcon />
	</Button>
);

const DeleteButton = ({ record, isAdmin, ...props }) => {
	const deleted = get(record, "deleted");
	if (deleted) {
		return <CantDelete />;
	}
	const canShow = get(record, "can_delete");
	if (!canShow) {
		return <CantDelete />;
	}
	return (
		<DeleteWithConfirmButton
			record={record}
			confirmContent="resources.user-wtrs.actions.delete.confirm_content"
			{...props}
		/>
	);
};

export default DeleteButton;
